module.exports = __webpack_public_path__ + "img/gradient.117597e6.png";